import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { green, red } from '@mui/material/colors';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import { ratingTrends } from 'shared/constants/ratingTrends';

const useTrendStyles = makeStyles({
  icon: {
    marginLeft: 10,
  },
  better: {
    color: green[400],
  },
  worse: {
    color: red[400],
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
});

const TrendIcon = ({ trend }) => {
  const trendClasses = useTrendStyles();

  const getRatingTrendClass = value => {
    switch (value) {
      case ratingTrends.up:
        return trendClasses.better;
      case ratingTrends.down:
        return trendClasses.worse;
      default:
        return undefined;
    }
  };

  if (!trend) {
    return null;
  }

  return <FiberManualRecordIcon className={clsx(trendClasses.icon, getRatingTrendClass(trend))} />;
};

TrendIcon.defaultProps = {
  trend: undefined,
};

TrendIcon.propTypes = {
  trend: PropTypes.oneOf([ratingTrends.up, ratingTrends.down]),
};

export default TrendIcon;
